import { Registry } from '~/models/registry';

export default {} as { currentRegistry?: Registry };
